<div class="fullbg">
    <div class="fullbginner">
        <div class="blueprint-grid"></div>
        <div class="safetly-logo safetly-logo-1"></div>
        <div class="safetly-logo safetly-logo-2"></div>
        <div class="safetly-logo safetly-logo-3"></div>
        <div class="safetly-logo safetly-logo-4"></div>
        <div class="safetly-logo safetly-logo-5"></div>
        <div class="safetly-logo safetly-logo-6"></div>
        <div class="safetly-logo safetly-logo-7"></div>
        <div class="safetly-logo safetly-logo-8"></div>
        <div class="safetly-logo safetly-logo-9"></div>
        <div class="safetly-logo safetly-logo-10"></div>
        <div class="safetly-logo safetly-logo-11"></div>
        <div class="safetly-logo safetly-logo-12"></div>
        <div class="safetly-logo safetly-logo-13"></div>
        <div class="safetly-logo safetly-logo-14"></div>
        <div class="safetly-logo safetly-logo-15"></div>
        <div class="safetly-logo safetly-logo-16"></div>
        <div class="safetly-logo safetly-logo-17"></div>
        <div class="safetly-logo safetly-logo-18"></div>
        <div class="safetly-logo safetly-logo-19"></div>
        <div class="safetly-logo safetly-logo-20"></div>
        <div class="safetly-logo safetly-logo-21"></div>
        <div class="safetly-logo safetly-logo-22"></div>
        <div class="safetly-logo safetly-logo-23"></div>
        <div class="safetly-logo safetly-logo-24"></div>
        <div class="blueprint-shield blueprint-element"></div>
        <div class="blueprint-lock blueprint-element"></div>
        <div class="blueprint-document blueprint-element"></div>
        <div class="blueprint-key blueprint-element"></div>
        <div class="blueprint-circuit"></div>
        <div class="blueprint-pulse blueprint-pulse-1"></div>
        <div class="blueprint-pulse blueprint-pulse-2"></div>
        <div class="blueprint-pulse blueprint-pulse-3"></div>
    </div>
</div>
<div class="box-header">
    <h2 class="box-header-left">On-boarding</h2>
    <mat-icon class="box-header-right" (click)="closeOnboarding()">close</mat-icon>
</div>
<div class="main-wrapper">
    <div class="onboarding-container">
        <div class="onboarding-center">
            <div class="order-methods">
                <div class="order-method" [class.active]="orderMethod === 'company'"
                    (click)="setOrderMethod('company')">
                    <div class="order-method-content">
                        <mat-icon>business</mat-icon>
                        <span>{{ "onboarding.option1" | translate }}</span>
                    </div>
                    <div class="check-icon-box">
                        <mat-icon>check</mat-icon>
                    </div>
                </div>
                <div class="order-method" [class.active]="orderMethod === 'person'" (click)="setOrderMethod('person')">
                    <div class="order-method-content">
                        <mat-icon>person</mat-icon>
                        <span>{{ "onboarding.option2" | translate }}</span>
                    </div>
                    <div class="check-icon-box">
                        <mat-icon>check</mat-icon>
                    </div>
                </div>
            </div>
            <!-- company form tab -->
            <div *ngIf="orderMethod === 'company'">
                <div class="business-info-form" *ngIf="companyFormStep === 1">
                    <h3>{{ "onboarding.company-form.title" | translate }}</h3>
                    <div class="order-form">
                        <label for="business-name">{{"onboarding.company-form.business-name" | translate}}</label>
                        <div class="search-input">
                            <input type="text" id="business-name" [(ngModel)]="businessNumber"
                                placeholder="{{'onboarding.company-form.search-input-placeholder' | translate}}" />
                            <!-- <input type="number" id="business-name" [(ngModel)]="businessNumber"
                                placeholder="{{'onboarding.company-form.search-input-placeholder' | translate}}" /> -->

                            <button (click)="searchBusiness()" class="search-btn" aria-label="Search">
                                <mat-icon [matTooltip]="'onboarding.search-tooltip' | translate" matTooltipPosition="above" class="search-icon" color="primary">
                                    search
                                </mat-icon>
                            </button>
                        </div>

                        <div *ngIf="searchError" class="error-message">
                            <mat-icon color="warn">error</mat-icon>
                            <p>{{ searchError }}</p>
                        </div>

                        <!-- Search Results -->
                        <div class="search-results" *ngIf="searchResults.length > 0">
                            <div class="search-result-item" *ngFor="let company of searchResults"
                                (click)="selectCompany(company)">
                                <div class="company-info">
                                    <h4>{{ company.companyName | titlecase }}</h4>
                                    <p>{{ company.idNumber }}</p>
                                    <p>
                                        {{ company.address }},
                                        {{ company.city }}
                                    </p>
                                </div>
                                <mat-icon>arrow_forward</mat-icon>
                            </div>
                        </div>
                        <div class="order-status" *ngIf="orderPlaced">
                            {{ "onboarding.company-form.order-status" | translate }}
                        </div>
                    </div>
                </div>
                <!-- Company Details Form -->
                <div class="company-details-form" *ngIf="companyFormStep === 2">
                    <div class="order-form">
                        <div class="company-details">
                            <div class="company-header">
                                <h3>{{ "onboarding.company-form.company-details-form.title" | translate }}</h3>
                                <div class="company-verified">
                                    <mat-icon>verified</mat-icon>
                                    {{ "onboarding.company-form.company-details-form.verified" | translate }}
                                </div>
                            </div>

                            <div class="company-info-grid">
                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.company-name" | translate }}</label>
                                    <p>{{ selectedCompany?.companyName || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.organization-number" | translate }}</label>
                                    <p>{{ selectedCompany?.idNumber || "-" }}</p>
                                </div>

                                <div class="info-group full-width">
                                    <label>{{ "onboarding.company-form.company-details-form.address" | translate }}</label>
                                    <p>
                                        {{ selectedCompany?.address || "-" }},
                                        {{ selectedCompany?.city || "-" }}
                                    </p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.country" | translate }}</label>
                                    <p>{{ selectedCompany?.country || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.email" | translate }}</label>
                                    <p>{{ selectedCompany?.email || employee?.email }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.phone" | translate }}</label>
                                    <p>{{ selectedCompany?.phone || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.company-form.company-details-form.website" | translate }}</label>
                                    <p>{{ selectedCompany?.customerWebsite || "-" }}</p>
                                </div>
                            </div>

                            <div class="action-buttons">
                                <button class="search-again-btn" (click)="searchAgain()" aria-label="Search Again">
                                    {{ "onboarding.company-form.company-details-form.search-again" | translate }}
                                </button>
                                <button class="confirm-btn" mat-flat-button color="primary" *ngIf="selectedCompany" (click)="confirmCompanyDetails()" aria-label="Confirm Company">
                                    {{ "onboarding.company-form.company-details-form.confirm-company-button" |  translate }}
                                    <mat-icon>check</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- person verification tab -->
            <div *ngIf="orderMethod === 'person'">
                <div class="bank-id-container" *ngIf="personFormStep === 1">
                    <div class="bank-id-steps">
                        <ol class="steps-list">
                            <li class="step">
                                <div class="step-number">1</div>
                                <div class="step-content">
                                    <h5>
                                        {{ "onboarding.person-form.step1" | translate }}
                                    </h5>
                                    <p>
                                        {{ "onboarding.person-form.step1-content" | translate }}
                                    </p>
                                </div>
                            </li>
                            <li class="step">
                                <div class="step-number">2</div>
                                <div class="step-content">
                                    <h5>
                                        {{ "onboarding.person-form.step2" | translate }}
                                    </h5>
                                    <p>
                                        {{ "onboarding.person-form.step2-content" | translate }}
                                    </p>
                                </div>
                            </li>
                            <li class="step">
                                <div class="step-number">3</div>
                                <div class="step-content">
                                    <h5>
                                        {{ "onboarding.person-form.step3" | translate }}
                                    </h5>
                                    <p>
                                        {{ "onboarding.person-form.step3-content" | translate }}
                                    </p>
                                </div>
                            </li>
                        </ol>
                        <div class="info-note">
                            <mat-icon class="info-icon">info</mat-icon>
                            <p>
                                {{ "onboarding.person-form.info-note" | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="order-section">
                        <div class="verification-box">
                            <h3>
                                <mat-icon class="bank-id-icon">perm_identity</mat-icon>
                                {{ "onboarding.person-form.order-section.title" | translate }}
                            </h3>
                            <p class="scan-instructions">
                                {{ "onboarding.person-form.order-section.scan-instructions" | translate }}
                            </p>
                            <div class="qr-code-box">
                                <div *ngIf="loading" class="loading-spinner">
                                    <mat-spinner diameter="40"></mat-spinner>
                                    <p>
                                        {{ "onboarding.person-form.order-section.loading" | translate }}
                                    </p>
                                </div>

                                <qr-code *ngIf="qrCodeUrl && !loading" [value]="qrCodeUrl" size="250" width="250"
                                    height="250" errorCorrectionLevel="M">
                                </qr-code>
                            </div>

                            <span class="open-bankid-link">
                                <span><mat-icon class="phone-icon">stay_primary_portrait</mat-icon></span>
                                {{ "onboarding.person-form.order-section.qr-code-box.title" | translate }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="person-verification-container" *ngIf="personFormStep === 2">
                    <div class="order-form">
                        <div class="person-details">
                            <div class="person-header">
                                <div class="person-header-content">
                                    <h3>
                                        {{ "onboarding.person-form.person-details.title" | translate }}
                                    </h3>
                                </div>
                                <div class="person-verified">
                                    <mat-icon>verified</mat-icon>
                                    {{ "onboarding.person-form.person-details.verified" | translate }}
                                </div>
                            </div>

                            <div class="person-info-grid">
                                <div class="info-group">
                                    <label>{{ "onboarding.person-form.person-details.first-name" | translate }}</label>
                                    <p>{{  bankIdUserDetails?.firstName || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.person-form.person-details.last-name" | translate }}</label>
                                    <p>{{ bankIdUserDetails?.lastName || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.person-form.person-details.personal-id" | translate }}</label>
                                    <p>{{ bankIdUserDetails?.personalNumber || "-" }}</p>
                                </div>

                                <div class="info-group">
                                    <label>{{ "onboarding.person-form.person-details.email" | translate }}</label>
                                    <p>{{ bankIdUserDetails?.email || "-" }}</p>
                                </div>
                            </div>

                            <div class="action-buttons">
                                <div class="person-verified">
                                    <mat-icon>verified</mat-icon>
                                    {{ "onboarding.person-form.person-details.identity-confirmed" | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <button class="continue-btn" 
                        [disabled]="!bankIdStatus || bankIdStatus !== 'complete'" 
                        [ngClass]="{disabled: !bankIdStatus || bankIdStatus !== 'complete'}" 
                        (click)="onContinueClick()" aria-label="Continue">
                        {{ "buttons.continue" | translate }}
                        <mat-icon class="arrow-right-icon">arrow_forward</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>